import { useState } from 'react';
import { useDispatch } from 'react-redux';
import l from '../../../lang';
import { useDashboard } from '../../../store/dashboard';
import { useAuth } from '../../../store/auth';
import { postTask } from '../../../services';
import { Urls } from '../../../config/urls';
import { loginSuccess } from '../../../store/auth/actions';
import { redirecTo } from '../../../utils';
import { Routes } from '../../../config/routes';
import './styles.scss';

const ImpersonationBanner = () => {
  const dispatch = useDispatch();
  const { merchantMe, userMe, initDashboard } = useDashboard();
  const { token, impersonationAdminEmail, setImpersonationAdminEmail } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!merchantMe?.impersonated) {
    return null;
  }

  const onExitImpersonation = async () => {
    if (!token) {
      setError(l('impersonation.exitError'));
      return;
    }
    setLoading(true);
    setError('');
    const { response, error: requestError } = await postTask({
      url: Urls.api.exitImpersonation,
      token,
      body: {
        adminUserEmail: impersonationAdminEmail || undefined,
      },
    });
    setLoading(false);

    if (response?.token) {
      setImpersonationAdminEmail(undefined);
      dispatch(loginSuccess(response));
      initDashboard();
      redirecTo(Routes.HOME);
      return;
    }

    setError(requestError?.message || l('impersonation.exitError'));
  };

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner__message">{l('impersonation.banner.message', userMe?.email || '-')}</div>
      <button className="impersonation-banner__link" onClick={onExitImpersonation} disabled={loading} type="button">
        {l('impersonation.banner.exit')}
      </button>
      {error && <div className="impersonation-banner__error">{error}</div>}
    </div>
  );
};

export default ImpersonationBanner;
